module.exports = __webpack_public_path__ + "static/media/left-chevron.a6bdaddc.svg";